export const SSR_INDICATOR = `SsrIndicator`;
export const SEGMENTED_CONTROL = 'segmentedControl';
